import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  CalendarFull,
  Cart,
  Envelope,
  InterlibraryLoans,
  Angle,
  QuestionMarkSquared
} from '@bibliocommons/base-icons';

import './DidNotFindServiceItem.scss';

const mapIcon = (service) => {
  switch (service) {
    case 's4p':
      return <Cart />;
    case 'bookAnAppt':
      return <CalendarFull />;
    case 'contactUs':
      return <Envelope />;
    case 'interLibraryLoans':
      return <InterlibraryLoans />;
    case 'askAQuestion':
      return <QuestionMarkSquared />;
    default:
      return <noop />;
  }
};

export default function DidNotFindServiceItem({ className, serviceId, serviceName, serviceLink }) {
  return (
    <li className={`service-item ${className}`}>
      {mapIcon(serviceId)}
      <a className={`did-not-find-service-link-${serviceId}`} href={serviceLink}>
        <FormattedMessage id={`${serviceName}`} />
        <Angle.Right />
      </a>
    </li>
  );
}

DidNotFindServiceItem.propTypes = {
  className: PropTypes.string,
  serviceId: PropTypes.string,
  serviceName: PropTypes.string,
  serviceLink: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/search/DidNotFindServiceItem/DidNotFindServiceItem.jsx